"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _core = require("@material-ui/core");

var _excluded = ["defaultValue", "onClick"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var PageNumField = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var defaultValue = _ref.defaultValue,
      onClick = _ref.onClick,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      color: "white"
    }
  }, /*#__PURE__*/_react["default"].createElement(_core.TextField, _extends({
    style: {
      width: "60px"
    },
    size: "small",
    variant: "outlined",
    id: "standard-basic",
    defaultValue: defaultValue,
    type: "number",
    InputProps: {
      inputProps: {
        min: 0
      }
    },
    onClick: onClick
  }, rest)));
});

var _default = PageNumField;
exports["default"] = _default;
PageNumField.defaultProps = {
  defaultValue: 0,
  onClick: null
};